import React from "react";
import { NoSettings } from "./sectionFormKit";

// Customer: components/sections/PaymentSuccess/PaymentSuccess.js
const PaymentSuccess = () => <NoSettings text="Payment confirmation message. No settings." />;

export default PaymentSuccess;
